<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle2">CONTENTS</h2>
<p class="toc"><a href="#/03_fm01">Introduction</a></p>
<p class="toc"><span href="#/04_fm02" title="Link target outside of Sample">Timeline</span></p>
<p class="toc1"><span href="#/05_chapter01" title="Link target outside of Sample">Chapter 1: The Persian Wars</span></p>
<p class="toc"><span href="#/06_chapter02" title="Link target outside of Sample">Chapter 2: The Peloponnesian War</span></p>
<p class="toc"><span href="#/07_chapter03" title="Link target outside of Sample">Chapter 3: The Rise of Macedonia: Philip II and Alexander the Great</span></p>
<p class="toc1"><span href="#/08_chapter04" title="Link target outside of Sample">Sources</span></p>
<p class="toc"><span href="#/09_chapter05" title="Link target outside of Sample">Acknowledgements</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_contents.vue?36a48c5c